import { type ReactElement, type ReactNode } from 'react';
import { Tooltip } from '@aibuild/ui';

/** Mirrors `ConfigFieldOptionDto` so a `ConfigFieldDto.options` array passes
 *  straight through. `descriptionNode` wins over `description`. */
export interface SelectFieldOption {
  readonly value: string;
  readonly label: string;
  readonly description?: string | null;
  readonly descriptionNode?: ReactNode;
}

/** `fullWidth`: the default `inline-flex` wrapper shrinks to content and the
 *  options wrap as chips instead of stacking. */
export const withDescriptionTooltip = (
  option: SelectFieldOption | undefined,
  node: ReactElement,
): ReactElement => {
  // Whitespace-only would pass a bare truthy guard and mount an empty bubble.
  const trimmed = option?.description?.trim();
  const content = option?.descriptionNode ?? (trimmed || undefined);
  if (!content) return node;
  return (
    <Tooltip content={content} placement="right" portal fullWidth>
      {node}
    </Tooltip>
  );
};
